export const turboPlugin = (() => {
  const handleMissingFrameAndRedirect = (event) => {
    if (event.detail.response.redirected) {
      event.preventDefault()
      event.detail.visit(event.detail.response)
    }
  }

  const addTurboStreamRenderedVisibility = (event) => {
    const streamElement = event.target

    // Prevent duplicate observers
    if (streamElement.dataset.renderedObserverAttached === "true") return
    streamElement.dataset.renderedObserverAttached = "true"

    const action = streamElement.getAttribute("action")
    const target = streamElement.getAttribute("target")

    const observer = new MutationObserver((mutations) => {
      observer.disconnect()

      // Prevent double-dispatch by using a flag
      if (streamElement.dataset.renderedFired) return
      streamElement.dataset.renderedFired = "true"

      const customEvent = new CustomEvent("turbo:stream-rendered", {
        bubbles: true,
        detail: {
          action,
          target,
          mutations,
        },
      })

      streamElement.dispatchEvent(customEvent)
    })

    // Observe the parent of the target, or the document body as a fallback
    const targetElement = target && document.getElementById(target)
    const observeRoot = targetElement?.parentNode || document.body

    observer.observe(observeRoot, {
      childList: true,
      subtree: true,
    })
  }

  return {
    init() {
      window.TOOLX = window.TOOLX || {}
      window.TOOLX.turbo = window.TOOLX.turbo || {}
      window.TOOLX.turbo.listeners = window.TOOLX.turbo.listeners || {}

      window.TOOLX.turbo.listeners.handleMissingFrameAndRedirect = window.TOOLX.turbo.listeners.handleMissingFrameAndRedirect || {
        status: "inactive",
        name: "turbo:frame-missing",
        fn: handleMissingFrameAndRedirect,
      }

      window.TOOLX.turbo.listeners.addTurboStreamRenderedVisibility = window.TOOLX.turbo.listeners.addTurboStreamRenderedVisibility || {
        status: "inactive",
        name: "turbo:before-stream-render",
        fn: addTurboStreamRenderedVisibility,
      }

      Object.entries(window.TOOLX.turbo.listeners).forEach(([, listener]) => {
        if (listener.status === "inactive") {
          document.addEventListener(listener.name, listener.fn)
          listener.status = "active" // Update status to active after adding the listener
        }
      })
    },
  }
})()

export default turboPlugin
